export default {
    createFormDataForSecondStepFromResponse(response) {
        let formData = { };

        if (response.beneficiary) {
            formData.beneficiary = response.beneficiary;
        }

        return formData;
    }
};